import { Typography, TypographyProps } from "@mui/material";

export function ScreenTitle(props: Omit<TypographyProps, "variant">) {
  return (
    <Typography
      fontWeight={300}
      fontFamily="'PP Fragment', sans-serif"
      variant="h4"
      {...props}
    />
  );
}

export function Header40(props: Omit<TypographyProps, "variant">) {
  return (
    <Typography
      fontWeight={300}
      fontFamily="'PP Fragment', sans-serif"
      fontSize={{ xs: 32, md: 40 }}
      {...props}
    />
  );
}

export function Header32(props: Omit<TypographyProps, "variant">) {
  return (
    <Typography
      fontWeight={300}
      fontFamily="'PP Fragment', sans-serif"
      fontSize={{ xs: 24, md: 32 }}
      {...props}
    />
  );
}

export function Header24(props: Omit<TypographyProps, "variant">) {
  return (
    <Typography
      fontWeight={300}
      fontFamily="'PP Fragment', sans-serif"
      fontSize={{ xs: 20, md: 24 }}
      {...props}
    />
  );
}

export function Header20(props: Omit<TypographyProps, "variant">) {
  return (
    <Typography
      fontWeight={300}
      fontFamily="'PP Fragment', sans-serif"
      fontSize={{ xs: 18, md: 20 }}
      {...props}
    />
  );
}
